import { Box, CloseIcon, IconButton, Typography } from '@methanesat/ui-components';
import { DrawerContainer } from '../DrawerContainer';
import { DrawerWithCardsProps } from '../../../../types';
import { ShareableLink } from '../Headers';

/**
 * Generic drawer with header and expandable content.
 */
export const DrawerWithCards = ({
    children,
    'data-testid': dataTestId,
    onClose,
    open,
    paperRef,
    resetScrollOnChange,
    setSnapPoint,
    snapPoint,
    shareable = false,
    title
}: DrawerWithCardsProps) => {
    return (
        <DrawerContainer
            data-testid={dataTestId || 'drawer-with-cards'}
            open={open}
            onClose={onClose}
            snapPoint={snapPoint}
            setSnapPoint={setSnapPoint}
            paperRef={paperRef}
            resetScrollOnChange={resetScrollOnChange}
            header={
                <>
                    <Box flexGrow="1" textAlign="center" paddingY={1}>
                        {title && <Typography component="span">{title}</Typography>}
                    </Box>
                    <Box sx={(theme) => ({ position: 'absolute', right: theme.spacing(2) })}>
                        {shareable && <ShareableLink />}
                        <IconButton
                            data-testid="close-drawer-button"
                            // todo: make sure onClose works with esc key - the test
                            // passes, but pressing 'esc' in storybook isn't
                            // triggering the onClose function
                            onClick={(ev) => onClose && onClose(ev, 'escapeKeyDown')}
                            color="primary"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </>
            }
        >
            <Box marginX={-1} width="auto">
                <Box marginTop={0} paddingX={3}>
                    {/* Cards */}
                    {children}
                </Box>
            </Box>
        </DrawerContainer>
    );
};
